import React from 'react';
import { connect } from 'react-redux';
import { Button } from 'react-admin';
import qs from 'qs';
import api from '../../lib/api';

class ExportAction extends React.Component {
  state = {
    loading: false,
  };

  handleClick = () => {
    const { resource, sort, filter } = this.props;
    const params = {
      sort,
      filter,
    };

    this.setState({ loading: true });
    api({
      url: `/${resource}/csv?${qs.stringify(params)}`,
      method: 'GET',
      responseType: 'blob',
    })
      .then(res => {
        const url = window.URL.createObjectURL(new Blob([res.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', 'users.csv');
        document.body.appendChild(link);
        link.click();
      })
      .finally(() => this.setState({ loading: false }));
  };

  render() {
    const { loading } = this.state;
    return (
      <Button
        color="primary"
        onClick={this.handleClick}
        disabled={loading}
        style={{ paddingTop: 4, paddingBottom: 4 }}
        label="Export"
      />
    );
  }
}

export default connect(
  null,
  null,
)(ExportAction);



// WEBPACK FOOTER //
// ./src/resources/users/ExportAction.jsx